import SidebarProvider from "@/v2-backoffice-client/components/sidebar/SidebarProvider"
import type { SidebarContentProps } from "@/v2-backoffice-client/components/sidebar/SidebarContent"
import SidebarContent from "@/v2-backoffice-client/components/sidebar/SidebarContent"

export type SidebarProps = SidebarContentProps

function Sidebar(props: SidebarProps) {
  return (
    <SidebarProvider>
      <SidebarContent {...props} />
    </SidebarProvider>
  )
}

export default Sidebar
